import React from 'react'
import './Container.css'
import BreadcrumbLayout from '../breadcrumbs/BreadcrumbLayout'
import Typo from '../typo/Typo'
import { CONTAINER_STYLE } from '../../../utils/constants/GlobalConstants'

const Container = (props) => {
    return (
             
             <div className='layout' style={props.style}>
                <div style ={CONTAINER_STYLE}>
            {props.breadCrumb && <BreadcrumbLayout activeLink={props.activeBreadCrumbLink ? props.activeBreadCrumbLink : [] } />}
           
        </div>
            <div className='page-header border-bt'>
                <Typo variant='h4' text={props.title} color="secondary" />
            </div>
         
            {props.children}
           
        </div>
       
      

    )
}

export default Container